<template>
  <div>
    <div class="title">
      <el-breadcrumb>
        <el-breadcrumb-item>店铺装修</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
        <div class="main" v-if="show" >
          <div class="loading">
              <h3>暂无店铺请去店铺管理申请</h3> 
              <span @click="$route.push('/home/shopManage')" class="btn">去申请店铺</span>
          </div>
      
    </div>
    <div class="main" v-else>
      <div class="toolslist">
        <ul>
          <li v-for="(item, index) in list"
              :key="index"
              @click="togo(item)">
            <h3 class="Itemleft" :class="item.type==1?'color1':item.type==2?'color2':item.type==3?'color3':'color4'">{{item.type==1?'品牌官方店':item.type==2?'品牌旗舰店':item.type==3?'品牌专卖店':'品牌专营店'}}</h3>
            <h2 :class="item.name.length>11?'shopname':'shopname1'">{{item.name}}</h2>
          
          </li>
        </ul>
      </div>
      <!-- 分页 -->
      <div class="pageSize">
        <el-pagination background
                       v-if="list.length>0"
                       @current-change="handleCurrentChange"
                       :current-page="page"
                       layout="total, prev, pager, next, jumper"
                       :total="total">
        </el-pagination>
      </div>
    </div>

  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  props: {

  },
  data () {
    return {
      list: [],
      total: 0,
      page: 1,
      size: 9,
      show:false,
    };
  },
  mounted () {
  this.getdecorateShopList()
  },
  computed: {
    ...mapGetters({
      getToken: "getToken",
    }),
  },
  methods: {
    ...mapActions({
      decorateShopList: "detect/decorateShopList",
    }),
    handleCurrentChange (val) {
      this.page = val;
      // this.getproductDetailList()
    },
    togo (item) {
      this.$router.push({
        path: '/home/fixShop',
        query: {
          id: item.id
        }
      })
    },
    getdecorateShopList () {
      let params = {
        token: this.getToken,
        page: this.page,
        limit: this.size
      }
      this.decorateShopList(params).then(res => {
        if (res.data.code==1) {
          this.list = res.data.data.shop
          this.total = parseInt( res.data.data.total)
        }else{
          this.$message.error(res.data.msg);
          this.show = true
        }
      })
    }
  },
  components: {

  },
};
</script>

<style scoped lang="scss">
.loading{
  padding-top: 20px;
display: flex;
justify-content: center;
align-items: center;
flex-direction: column;
.btn{
  margin-top: 40px;
  width: 200px;
  height: 40px;
  background-color: #409EFF;
  color: #fff;
  font-size: 16px;
  line-height: 40px;
  text-align: center;
  border-radius: 10px;
}
}
.color1 {
  color: red;
}
.color4 {
  color: rgb(0, 4, 255);
}
.color2 {
  color: rgb(236, 4, 229);
}
.color3 {
  color: orange;
}
.pageSize {
  text-align: center;
  margin-top: 20px;
}
.title {
  width: 100%;
  background: #fff;
  font-size: 20px;
  color: #000000;
  width: 100%;
  padding: 15px 32px;
  box-shadow: 0px 0px 8px 0px rgb(100 100 100 / 17%);
}
.main {
  min-height: 760px;
  box-shadow: 0px 0px 8px 0px rgba(100, 100, 100, 0.17);
  background: #fff;
  margin: 24px;
  padding: 20px;
  padding-bottom: 70px;
  min-width: 1200px;
  box-sizing: border-box;
  .toolslist {
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    ul {
      list-style: none;
      width: 100%;
      box-sizing: border-box;
      padding-left: 80px;
      display: inline-block;
      // float: left;
      text-align: center;
      margin-bottom: 50px;
      li {
        overflow: hidden;
        box-sizing: border-box;
        cursor: pointer;
        margin-top: 30px;
        width: 25%;
       // height: 160px;
        min-height: 160px;
        background: #ffffff;
        border: 1px solid #dddddd;
        border-radius: 8px;
        float: left;
        margin-right: 60px;
        padding-bottom: 20px;
        .Itemleft {
          box-sizing: border-box;
          width: 100%;
          display: inline-block;
          height: 31px;
          line-height: 31px;
          text-align: right;
          border-radius: 4px;
          padding: 6px 10px 0 0px;
        }
        .shopname {

          padding: 10px 20px;
        }
        .shopname1 {
          text-align: center;
         line-height: 100px;
        }
        .imgItem {
          margin: 20px 0;
          display: flex;
          justify-content: center;
          // align-items: center;
          div {
            width: 90px;
            height: 90px;
            img {
              width: 90px;
              height: 90px;
            }
          }
        }
      }
    }
  }
}
</style>
